module.exports = __webpack_public_path__ + "img/currie-cup-logo-default.b6d6993f.png";